import {post} from "./base";

export async function getAll(accessToken) {
  const result = await post("centri/GetCentri", {accessToken});
  return result.map((u) => ({
    ...u,
    // fullname: u.firstname + " " + u.lastname,
    // specializzazione: u.specializzazione,
    // address: u.address
  }));
  // "idMedico", "firstname", "lastname", "dateCreated", "idAgente", "email", "phone" ("agente" if admin)
}
export async function add(accessToken, data) {
  await post("centri/AddCentro", {jsonBody: {...data, accessToken}});
  console.log(`Centro ${data} added`);
}

export async function remove(accessToken, id_centro) {
  await post("centri/DeleteCentro", {jsonBody: {accessToken, id_centro}});
  console.log(`Centro ${id_centro} deleted`);
}
